<script>
  import { fade } from "svelte/transition";
  import { slide } from "../data/slideInvert";

  export let actualAccident;
  export let expectedAccident;

  let ratio = actualAccident / expectedAccident;
</script>

<style lang="scss">
  .bar {
    height: 10px;
    background-color: darkcyan;

    &--actual {
      background-color: gainsboro;
      height: 100%;
    }
  }
</style>

<div
  class="bar"
  in:fade={{ duration: 200, delay: 250 }}
  out:fade={{ duration: 200 }}>
  <div
    class="bar bar--actual"
    style="width: {ratio * 100}%;"
    in:slide={{ duration: 200, delay: 250 }}
    out:slide={{ duration: 200 }} />
</div>
